import EventQuery from "@grindex-client/components/Search/Query/event-query.class";
import DateSearch from "@grindex-client/components/Search/Extensions/date-search.class";
import EventManager from "@grindex-common/helpers/EventManager.class";
import DirtyManager from "@grindex-client/components/Search/Extensions/DirtyManager.class";
import SearchHeader from "@grindex-client/components/Search/Extensions/SearchHeader.class";
import { events } from "@grindex-common/helpers/events";
import { FacetsManager } from "@grindex-client/components/Search/Extensions/facets-search.class";

export default class EventSearch extends DateSearch {
	searchHeader: SearchHeader;
	facetsManager: FacetsManager<EventQuery>;
	constructor($ownerModule: HTMLElement) {
		const query = new EventQuery();
		const eventManager = new EventManager();
		const dirtyManager = new DirtyManager();
		super($ownerModule, eventManager, dirtyManager, query);

		this.searchHeader = new SearchHeader($ownerModule, eventManager, query);
		this.searchHeader.initHeader(this.queryObject.getPagingData().pageSize);
		this.eventManager.on(this, events.search.CHANGE_PAGE_SIZE, this.onPageSizeChanged.bind(this));
		this.facetsManager = new FacetsManager($ownerModule, eventManager, dirtyManager, query);
		this.facetsManager.initFacets();
		this.eventManager.on(this, events.search.RENDERED, this.facetsManager.renderCurrentFilters.bind(this.facetsManager));
	}
	dateSearch(startDate, endDate, queryObject) {
		queryObject.setDates(startDate, endDate);

		this.search();
	}

	onPageSizeChanged() {
		this.search();
	}
}
